const DEFAULT_ROUTE = {
  startLocation: 'Lũng Cú',
  endLocation: 'Cà Mau',
};

function toNumber(value, fallback = 0) {
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
}

function normalizeParticipant(item, index, currentUserId) {
  const distanceRegister = toNumber(item.distance_register || item.distanceRegister, 0);
  const totalDistanceKm = toNumber(item.total_distance || item.totalDistance, 0) / 1000;
  const progressRatio = distanceRegister > 0 ? Math.min(totalDistanceKm / distanceRegister, 1) : 0;
  const userId = item.user_id || item.userId || item.strava_id || `participant-${index}`;

  return {
    userId,
    name: item.fullname || item.name || 'Vận động viên',
    avatar: item.avatar || '',
    registeredAt: item.registered_at || item.registeredAt || `fallback-${index}`,
    distanceRegister,
    totalDistance: Math.ceil(totalDistanceKm * 100) / 100,
    progressRatio,
    isCurrentUser: String(userId) === String(currentUserId),
  };
}

export function getRelayStatus(participant) {
  if (participant.progressRatio >= 1) return 'complete';
  if (participant.isCurrentUser) return 'current';
  return 'waiting';
}

export function buildRelayModel({
  campaignId,
  campaignName,
  leaderboard = [],
  currentUserId,
  route = {},
}) {
  // Merge provided route with defaults field-by-field so partial overrides work
  route = {
    startLocation: route.startLocation || DEFAULT_ROUTE.startLocation,
    endLocation:   route.endLocation   || DEFAULT_ROUTE.endLocation,
  };
  const participants = leaderboard
    .map((item, index) => normalizeParticipant(item, index, currentUserId))
    .sort((a, b) => String(a.registeredAt).localeCompare(String(b.registeredAt)))
    .map((participant) => ({
      ...participant,
      status: getRelayStatus(participant),
    }));

  const totalRegisteredDistance = participants.reduce(
    (sum, item) => sum + item.distanceRegister,
    0
  );
  const totalCompletedDistance = participants.reduce(
    (sum, item) => sum + Math.min(item.totalDistance, item.distanceRegister),
    0
  );

  return {
    campaignId,
    campaignName,
    startLocation: route.startLocation,
    endLocation: route.endLocation,
    totalRegisteredDistance,
    totalCompletedDistance,
    teamProgressRatio:
      totalRegisteredDistance > 0 ? totalCompletedDistance / totalRegisteredDistance : 0,
    participants,
  };
}
